import type { SupportedAlpha2CountryCode } from './getSupportedAlpha2CountryCodes'

import { getSupportedAlpha2CountryCodes } from './getSupportedAlpha2CountryCodes'

export const isSupportedAlpha2CountryCode = (
  value: string | null | undefined,
): value is SupportedAlpha2CountryCode => {
  if (!value) {
    return false
  }

  const supportedAlpha2CountryCodes = getSupportedAlpha2CountryCodes()

  return supportedAlpha2CountryCodes.includes(
    value as SupportedAlpha2CountryCode,
  )
}
